import React from 'react';
import PropTypes from 'prop-types';

const RenderItem = ({ src }) => (
  <div className="image-carousel-container">
    <img
      src={`${src}`}
      style={{
        objectFit: 'contain',
        height: '100%',
      }}
      alt="render.src"
    />
  </div>
);

RenderItem.propTypes = {
  src: PropTypes.string.isRequired,
};

export default RenderItem;
